module.exports = __webpack_public_path__ + "static/StarogardGdanski-45ec44f4d6601a89910bd96bbad620a6.svg";